import { lazy } from 'react';
export var VotingEditPageAsync = lazy(function () { return import('./VotingEditPage'); });
